export const getLangDefinition = (lang: string) => {
  switch (true) {
    case lang === 'ru':
      return lang;
    default:
      return 'az';
  }
};

export const getReversedLangDefinition = (lang: string) => {
  switch (lang) {
    case 'ru':
      return 'az';
    default:
      return 'ru';
  }
};
